import React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import theme from '../../../theme'
import styles from './FlatLabelsStyles'
import {
    colorFilterTextSelected,
    colorFilterIconUnselected,
    PostTagsTheme,
} from '../../../themeConstants'

const FlatLabels = ({ posts, onSelectLabel, extraStyle, isPost = false }) => {
    const textStyle = posts.isSelected
        ? styles.flatItemsSelected
        : styles.flatItemsUnselected

    return (
        <TouchableOpacity
            onPress={() => onSelectLabel(posts._id)}
            style={[
                styles.flatFlags,
                {
                    backgroundColor: posts.isSelected
                        ? PostTagsTheme.tagSelectedColor
                        : PostTagsTheme.tagUnselectedColor,
                },
                extraStyle,
                isPost && {
                    borderColor: posts.isSelected
                        ? PostTagsTheme.tagSelectedColor
                        : theme.colors.inputPlaceholder,
                },
            ]}
        >
            <Text style={[textStyle, isPost && { fontWeight: '600' }]}>
                {posts.name}
            </Text>
        </TouchableOpacity>
    )
}

export default FlatLabels
